import arrowleft from "@Images/NewUI/Vector.png";
import finvuIcon from "@Images/NewUI/finvu-img.png";
import { getRedirctionSahmati } from "@Redux/Manual_Kyc_Details/action";
import React, { useState } from 'react';
import Modal from "react-modal";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Shield from "../../../../src/Images/NewUI/Shield.png";
import Clock from "../../../../src/Images/NewUI/clock.png";
import Sparkimg from "../../../../src/Images/NewUI/spark.png";
import UploadSaf from "../../../../src/Images/NewUI/uploadbtn.png";
import Upload from "../../../../src/Images/NewUI/uploadd.png";
import DisclaimerImg from "../../../Images/NewUI/disclaimer.png";
import { notifyVisitorEvent } from "../../../Redux/ApplyLoan/action";
import ToastMsg from "../../../helper/ToastMsg";
import ModalBox from '../../../helper/modalBox';
import { payme_bank_statement_heading, payme_bank_statement_list } from '../../../helper/modalConstant';
import { BANK_STATEMENT } from "../Common/constant";

const Bankstatement = (props) => {
  const navigate = useNavigate();
  const [modalState, setModalState] = useState(false);
  const [showProceedPopUp, setShowProceedPopup] = useState(false);
  const mixpanelE_statement = () =>{
     setShowProceedPopup(true);
  }
  const handleRedirecttosahmati = () => {
    // e.preventDefault();
// console.log("lkns")
   props.getRedirctionSahmati(localStorage.getItem("gpay_token"))
      .then((res) => {
        setTimeout(() => {
          window.open(res.data, '_blank');
          setTimeout(() => {
            navigate("/completeprofilenew");
        }, 1000);
      }, 100);



        // window.location.href = res.data;
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
  const handleproceedClick = (e) => {
    e.preventDefault();
    setShowProceedPopup(false);
   
    handleRedirecttosahmati()
    // window.open(`https://finvu.paymeindia.in/?token=${localStorage.getItem('gpay_token') || localStorage.getItem('gpay_refresh_token') }`,"_blank")

  }

  return (
    <div className="main_div payme_body">
      <Modal
      isOpen={showProceedPopUp}
      className="proceed-popup"
      onRequestClose={() => setShowProceedPopup(false)} 
      >
        <h3>How it works?</h3>
        <p>You need to provide your account information on Finvu inorder to verify your bank statement</p>
        <h4>Steps:</h4>
        <ul>
          <li>Mobile OTP verification sent by Finvu</li>
          <li>Select your bank accounts</li>
          <li>Verify your accounts via OTP</li>
          <li>Track your bank transactions seamlessly</li>
        </ul>
        <div> <p>Powered by RBI regulated Account Aggregator: </p> <img src={finvuIcon} width={65} alt="finvu-con" />  </div>
        <div className="btn-wrapper"> <button onClick={handleproceedClick} >Proceed</button></div>
      </Modal>

    <div className="toolbarRespo">

        <div className=" sticky-header align-items-baseline d-flex justifycontentspacebtn width100per shadowline headBank">
        
              <div  style={{display:"flex", flexDirection:"row", alignItems:"center"}}>
              <img
                className=''
                style={{marginRight:"20px"}}
                  src={arrowleft}
                  onClick={() => {
                    window.location.href="/completeprofilenew"
                  }}
                />
             
              <span
              className=""
                style={{
                  color: "#152745",
                  fontWeight: "1000",
                  fontSize: "30px",
                }}
              >
                {BANK_STATEMENT}
              </span>
              </div>
        </div>

        <div className="container">
              <div className="repaymentdisclaimer2  flex_row ">
                  <img style={{marginRight: 13, marginTop: -19, marginLeft:10}} width={16} height={16} src={DisclaimerImg}></img>
                  <p className="selectrepaymentdatedisclaimercolour ">Please share the bank account statement of your primary account, where most of your earnings/ income/salary is credited, for the last 6 months.</p>
                </div>
        </div>
        <div className="cardbottomMargin aligncentrehere container">
        <span className='chooseOneLoan dispflex'>Choose one to continue</span>
              <div>
              <div className="cardstructureoption mt-23  ">
                <span className="aprooved">RECOMMENDED</span>  
              <div className="flex_row justifycontent  designfix ">
              <div className="flex_row marginTopNew">    
                    <span className="getLimitbtn"> E-Statement</span>
                  
              </div>

              <div className="marginTopNew displayfix">
              <span className="onetimePaymentgreen">Opted by <span style={{fontWeight: 700}}>90%</span> users</span>
              </div>
              </div>

              <div className="mr-20" >
              <div className=" flex_row ">
                  <p className="selectrepaymentdatedisclaimercolour">Verification will just take <b>30 seconds</b> </p>
                  <img style={{marginLeft: 4}} width={8} height={17} src={Sparkimg}></img>
                </div>
                <div className=" flex_row ">
                <p className="selectrepaymentdatedisclaimercolour"> <b>Instant</b> Loan Approval</p>
                </div>
              </div>

               <div className="Estatementbtn" style={{opacity: "1" }} onClick={mixpanelE_statement}>
               <img style={{marginRight:10}} width={28} height={28} src={Upload}></img>
                E-Statement</div> 
           
              </div>
              </div>
              <br/>
              <hr />
              <div className='orfix'>
              <span className='orpadding'>OR</span>
              </div>
              

              <div className="cardstructureoption mt-2  container">
                
              <div className="flex_row justifycontent ">

              <div className="flex_row marginTopNew"> 
                  
              <span className="getLimitbtn">Upload Statement</span>
              </div>


              <div className="marginTopNew displayfix">
             
              </div>
              </div>
             
               <div className=" flex_row ">
                  <p className="selectrepaymentdatedisclaimercolour"> Verification will take <b>2-3 Business hours</b> </p>
                  <img style={{marginLeft: 4 , marginTop: 4}} width={12} height={12} src={Clock}></img>
                </div>
                <div className=" flex_row ">
                <p className="selectrepaymentdatedisclaimercolour"> Loan Approval in <b>24 Hours</b></p>
                </div>

             <Link to="/bank_statement_upload">
             <div className="Estatementbtnoutline" style={{opacity: "1" }}>
               <img style={{marginRight:10}} width={28} height={28} src={UploadSaf}></img>
                Upload Statement
                </div> 
             </Link>
               
              </div>

              <div className='grncolour pb-10'>
               <img style={{marginRight:10}} width={18} height={18} src={Shield}></img>
               Your data is 100 % safe and secure</div> 
              
        </div>
    </div>
        {modalState && <ModalBox  heading={payme_bank_statement_heading} List={payme_bank_statement_list} open={true} onChange={(props)=>{setModalState(props)}} imagesVisible={true}/> }

    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default connect(mapStateToProps, {getRedirctionSahmati, notifyVisitorEvent})(Bankstatement);
